import { THM_SCOREBOARD } from "../apiEndpoint";
import { educationAxios } from "../http/http";

export default function userData(formData,email) {
    educationAxios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
  return educationAxios.post(THM_SCOREBOARD+'?user_email='+ email ,formData);
}
